"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuery = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const useDeepCompareEffect_1 = require("../hooks/useDeepCompareEffect");
function useQuery(_a) {
    var { handleQuery } = _a, queryOptions = tslib_1.__rest(_a, ["handleQuery"]);
    const [loading, setLoading] = react_1.useState(true);
    const [error, setError] = react_1.useState(undefined);
    const [data, setData] = react_1.useState(undefined);
    const fetchQuery = (queryOptions) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        try {
            setLoading(true);
            const data = yield handleQuery(queryOptions);
            setData(data);
        }
        catch (error) {
            setError(error);
        }
        finally {
            setLoading(false);
        }
    });
    const refetch = () => {
        fetchQuery(queryOptions);
    };
    useDeepCompareEffect_1.useDeepCompareEffect(() => {
        fetchQuery(queryOptions);
    }, [queryOptions]);
    return {
        loading,
        data,
        error,
        refetch,
    };
}
exports.useQuery = useQuery;
//# sourceMappingURL=Query.js.map